<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="seasonal-prizes"
    [viewName]="title"
    [record]="seasonalPrizesRecord"
    [fields]="fields"
    [sidebarFields]="sidebarFields"
    [parentViewName]="parentViewName">
</dynamic-view-v2>